class SlideDrawer extends HTMLElement {
  constructor() {
    super();
    this.drawerLabel = this.querySelector('#drawer-label');
    this.drawerContent = this.querySelector('#drawer');
    this.closeDrawerButton = this.querySelector('#close-drawer');
    this.overlay = this.querySelector('.overlay');

    this.drawerLabel.addEventListener('click', this.toggleDrawer.bind(this));
    this.closeDrawerButton.addEventListener('click', this.toggleDrawer.bind(this));
    this.overlay.addEventListener('click', this.toggleDrawer.bind(this));
    document.addEventListener('click', this.closeDrawer.bind(this));
  }

  toggleDrawer() {
    this.drawerContent.classList.toggle('active');
    if (this.drawerContent.classList.contains('active')) {
      document.querySelector('main').style.zIndex = "5";
      document.querySelector('.overlay').style.display = "block";
      document.body.style.overflow = "hidden";
    }else {
      document.querySelector('main').style.zIndex = "1";
      document.querySelector('.overlay').style.display = "none";
      document.body.style.overflow = "auto";
    }
  }

  closeDrawer(event) {
    if (!this.contains(event.target) && event.target !== this.drawerLabel) {
      this.drawerContent.classList.remove('active');
    }
  }
}

customElements.define('slide-drawer', SlideDrawer);